import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

import { FilterTag } from '@apps/cmdb/models';


@Component({
    selector: 'aa-filter-tag-input',
    templateUrl: './filter-tag-input.component.html',
    styleUrls: [
        './filter-tag-input.component.scss'
    ],
    standalone: false
})
export class FilterTagInputComponent implements OnInit
{
    @Input() tags: FilterTag[];
    @Input() public disabled = false;
    @Input() public placeholder: string = 'Click to filter on tags';
    @Output() public selectTag: EventEmitter<FilterTag> = new EventEmitter();
    public formGroup: UntypedFormGroup;
    public readonly ctrlFullTag: UntypedFormControl = new UntypedFormControl();
    public selectedTag: FilterTag;

    ngOnInit ():void
    {
        this.formGroup = new UntypedFormGroup({
            ctrlFullTag: this.ctrlFullTag
        });
    }

    public onClick (tag: FilterTag):void
    {
        this.selectedTag = tag;
        this.onSubmit();
    }

    private onSubmit (): void
    {
        if (this.selectedTag)
        {
            this.selectTag.emit(this.selectedTag);
            this.formGroup.get('ctrlFullTag').setValue('');
        }
    }
}
